module.exports = "<div class=\"router-outlet-class\">\r\n  <div class=\"col-md-12\">\r\n    <h4>Ekpay Canvas</h4>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboards/blank-dashboard/blank-dashboard.component.html
// module id = ./src/app/dashboards/blank-dashboard/blank-dashboard.component.html
// module chunks = main